<template>
  <a-drawer title="构建日志" :visible="visible" :width="900" @close="onClose">
    <div v-if="spinning" style="padding: 16px"><a-skeleton /></div>
    <div v-else class="drawer-content">
      <code-mirror-component v-model="logContent" :read-only="true" language="shell" />
    </div>
  </a-drawer>
</template>
<script>
import { pipelineRecordLog } from '@/api/project/pipeline';
import CodeMirrorComponent from '@/components/CodeMirrorComponent';

export default {
  components: { CodeMirrorComponent },
  props: {
    recordId: {
      type: [Number, String],
      default: null
    },
    nodeId: {
      type: [Number, String],
      default: null
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      logContent: '',
      spinning: true,
      projectId: parseInt(this.$route.params.project_id) || null
    };
  },
  watch: {
    visible() {
      if (this.visible === true) {
        this.spinning = true;
        this.getBuildLog();
      }
    }
  },
  methods: {
    onClose() {
      this.logContent = '';
      this.$emit('close');
    },
    getBuildLog() {
      pipelineRecordLog({ record_id: this.recordId, node_id: this.nodeId, project_id: this.projectId }).then(response => {
        this.spinning = false;
        if (this.nodeId === null) {
          this.logContent = response.data.logs.join('\n');
        } else {
          let content = response.data.logs.join('\n');
          const subStr1 = new RegExp('<span class="timestamp"><b>(.+)</b> </span><span style="display: none">', 'gm');
          content = content.replaceAll(subStr1, '');
          const subStr2 = new RegExp('</span>', 'gm');
          content = content.replaceAll(subStr2, '');
          this.logContent = content;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.drawer-content {
  overflow: auto;
  height: 100%;
}
/deep/.ant-drawer-body {
  padding: 0px;
  height: calc(~'100% - 55px');
}
</style>
